import { Pending } from '@cluey/cluey-components';
import classNames from 'classnames';
import React, { ReactNode, useEffect } from 'react';

import EnrolmentStatus from '../../components/EnrolmentManagement/EnrolmentStatus';
import { EnrolmentStatusReboarding } from '../../components/EnrolmentManagement/EnrolmentStatusReboarding';
import { ConnectedEnrolmentStatusSummerMode as EnrolmentStatusSummerMode } from '../../components/EnrolmentManagement/SummerMode/EnrolmentStatusSummerMode';
import { Loader } from '../../components/Loader/Loader';
import { formatError } from '../../util/errors';
import { isHolidayLearningAlertOn, scrollToTop } from '../../util/helpers';
import withHeadTag from '../HeadComponent';

/* eslint-disable react/no-unused-prop-types */
type EnrolmentLayoutProps = {
  isLoading?: boolean;
  error?: unknown;
  sectionHeading?: ReactNode;
  mainHeading?: ReactNode;
  mainHeadingClassName?: string;
  subHeading?: ReactNode;
  showEnrolmentStatus?: boolean;
  showSummerModeEnrolmentStatus?: boolean;
  enrolmentId?: string;
  children?: ReactNode;
  tracking?: string;
  // Retained for caller compatibility during the sidebar migration; the footer
  // (and its CTA border) now lives in the global app shell, so this is a no-op.
  // eslint-disable-next-line react/no-unused-prop-types
  hasCTAAboveFooter?: boolean;
  sectionHeadingLink?: string;
};

const EnrolmentLayout = ({
  isLoading = false,
  error,
  showEnrolmentStatus = false,
  showSummerModeEnrolmentStatus = false,
  children,
  tracking = null,
}: EnrolmentLayoutProps) => {
  useEffect(() => {
    scrollToTop();
  }, []);

  const shouldShowEnrolmentStatusReboarding =
    !showSummerModeEnrolmentStatus && showEnrolmentStatus && isHolidayLearningAlertOn();

  return (
    <div
      className={classNames('flex min-h-screen flex-col', {
        [tracking]: tracking !== null,
      })}
    >
      <Pending
        loading={isLoading}
        error={error ? formatError(error) : undefined}
        loader={
          <div className="mx-auto my-10">
            <Loader />
          </div>
        }
      >
        <div className="mb-20 flex flex-grow flex-col lg:mb-0">
          <div className="container px-5 md:px-10">
            {showEnrolmentStatus && <EnrolmentStatus />}
            {showSummerModeEnrolmentStatus && <EnrolmentStatusSummerMode />}
            {shouldShowEnrolmentStatusReboarding && <EnrolmentStatusReboarding />}
          </div>
          {children}
        </div>
      </Pending>
    </div>
  );
};

export default withHeadTag(EnrolmentLayout);
